module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-5 darker accountsTab"
  }, [_c('div', {
    staticClass: "w-100 mb-2 text-right"
  }, [_c('button', {
    staticClass: "btn widest ml-auto",
    on: {
      "click": _vm.addAccount
    }
  }, [_vm._v("Create Account")])]), _vm._v(" "), (_vm.getIsLoadingSupplierAccounts) ? _c('div', {
    staticClass: "col-sm-12 text-center"
  }, [_c('loader')], 1) : _c('div', {
    staticClass: "col-sm-12 mb-4"
  }, [_c('list', {
    staticClass: "w-100",
    attrs: {
      "header": _vm.header,
      "body": _vm.body,
      "rows": _vm.userAccounts,
      "actions": _vm.actions
    }
  })], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-7651af25", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7651af25"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/TabAccounts.vue
// module id = 2564
// module chunks = 0